export const SET_EDITABLE_TAX_RATE = 'SET_EDITABLE_TAX_RATE';

export const GET_STORE_TAX_RATES_START = 'GET_STORE_TAX_RATES_START';
export const GET_STORE_TAX_RATES_SUCCESS = 'GET_STORE_TAX_RATES_SUCCESS';
export const GET_STORE_TAX_RATES_FAILED = 'GET_STORE_TAX_RATES_FAILED';

export const CREATE_NEW_TAX_RATES_START = 'CREATE_NEW_TAX_RATES_START';
export const CREATE_NEW_TAX_RATES_SUCCESS = 'CREATE_NEW_TAX_RATES_SUCCESS';
export const CREATE_NEW_TAX_RATES_FAILED = 'CREATE_NEW_TAX_RATES_FAILED';

export const EDIT_TAX_RATE_START = 'EDIT_TAX_RATE_START';
export const EDIT_TAX_RATE_SUCCESS = 'EDIT_TAX_RATE_SUCCESS';
export const EDIT_TAX_RATE_FAILED = 'EDIT_TAX_RATE_FAILED';

export const DELETE_TAX_RATE_START = 'DELETE_TAX_RATE_START';
export const DELETE_TAX_RATE_SUCCESS = 'DELETE_TAX_RATE_SUCCESS';
export const DELETE_TAX_RATE_FAILED = 'DELETE_TAX_RATE_FAILED';

export const getStoreTaxRatesStart = () => ({
  type: GET_STORE_TAX_RATES_START
});

export const getStoreTaxRatesSuccess = (taxRates, taxRule) => ({
  type: GET_STORE_TAX_RATES_SUCCESS,
  taxRates,
  taxRule
});

export const getStoreTaxRatesFailed = (error) => ({
  type: GET_STORE_TAX_RATES_FAILED,
  error
});

export const setEditableTaxRate = (tax) => ({
  type: SET_EDITABLE_TAX_RATE,
  tax
});

export const createNewTaxRateStart = () => ({
  type: CREATE_NEW_TAX_RATES_START
});

export const createNewTaxRateSuccess = (newTaxRate) => ({
  type: CREATE_NEW_TAX_RATES_SUCCESS,
  newTaxRate
});

export const createNewTaxRateFailed = (error) => ({
  type: CREATE_NEW_TAX_RATES_FAILED,
  error
});

export const editTaxRateStart = () => ({
  type: EDIT_TAX_RATE_START
});

export const editTaxRateSuccess = (data) => ({
  type: EDIT_TAX_RATE_SUCCESS,
  data
});

export const editTaxRateFailed = (error) => ({
  type: EDIT_TAX_RATE_FAILED,
  error
});

export const deleteTaxRateStart = () => ({
  type: DELETE_TAX_RATE_START
});

export const deleteTaxRateSuccess = (idTaxRate, updatedTaxRule) => ({
  type: DELETE_TAX_RATE_SUCCESS,
  idTaxRate,
  updatedTaxRule
});

export const deleteTaxRateFailed = (error) => ({
  type: DELETE_TAX_RATE_FAILED,
  error
});
